export const getAccess = (authorities, hasAnyRole) => {
  if (authorities && authorities.length !== 0) {
    if (hasAnyRole.length === 0) {
      return true;
    }
    return hasAnyRole.some(auth => authorities.includes(auth));
  }
  return false;
};